export default __webpack_public_path__ + "static/media/CapaLogoBetaWhite.f5d999cd.svg";